import React, { useEffect, useState } from 'react';
import { VelocityFrequentFlyerForm } from '../Forms/VelocityFrequentFlyerForm';
import { VoucherAccordian } from '../VoucherAccordian';

function CartSummary({ cartData, showThirdParty }) {
	const [totalPrice, setTotalPrice] = useState(null);

	useEffect(() => {
		var val = getTotalPrice();
		setTotalPrice(val);
	}, [cartData]);

	const getTotalPrice = () =>
		cartData
			.map((item) => {
				let skus = item.product.skus[0];
				return skus.salePrice;
			})
			.reduce((a, b) => a + b);

	return (
		<div className='order__summary'>
			{showThirdParty && (
				<VoucherAccordian title='Velocity Membership Number'>
					<VelocityFrequentFlyerForm />
				</VoucherAccordian>
			)}
			<div className='d-flex justify-content-between mb-16 mt-16'>
				<div className='text-dark-medium'>Cart Summary</div>
				<div className='text-dark-medium'>
					{cartData?.length} item{cartData.length > 1 ? 's' : ''}
				</div>
			</div>
			<div className='d-flex justify-content-between mb-16'>
				<div className='text-dark-medium'>Shipping</div>
				<div className='text-dark-medium'>Calculated at checkout</div>
			</div>
			<div className='d-flex justify-content-between mb-16'>
				<h6 className='roboto lower'>Order Total</h6>
				<h6 className='roboto lower'>
					{totalPrice && `$${totalPrice.toFixed(2)}`}
				</h6>
			</div>
		</div>
	);
}

export default CartSummary;
